import { put } from "redux-saga/effects";
import { Update_username } from "../../Services";

export function* updateUsernameSaga(action) {
  const payload = action.payload;
  try {
    const res = yield Update_username(payload);

    yield put({ type: "REQ_CHANGE_USERNAME_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_CHANGE_USERNAME_FAILED", errData: e });
  }
}
